import * as React from "react";
import { Input } from "antd";
import DateRangePicker from "widget/dateRangePicker";
import inputEnhance from "widget/rewriteAntdHOC/input";
const InputEnhance = inputEnhance(Input);

interface INoticeSearchForm {
  getValue: any;
  setValue: any;
  // 模型名称
  modelName: any;
  // 表单查询
  onSearch: any;
  // 重置并查询
  onResetSearch: any;
}

// 消息查询表单
class NoticeSearchForm extends React.Component<INoticeSearchForm, any> {
  constructor(props: INoticeSearchForm) {
    super(props);
  }

  componentDidMount() {
    this.onReset();
  }

  // 日期选择事件
  dateChange = (data, dateString) => {
    let rangePickerData = {};
    rangePickerData["beginDate"] = dateString[0];
    rangePickerData["endDate"] = dateString[1];

    this.props.setValue({
      formInfo: rangePickerData,
      model: this.props.modelName
    });
  };

  getDateRangeValue = () => {
    return this.props.getValue(["beginDate", "endDate"]);
  };

  getKeysValue = () => {
    return this.props.getValue("keys");
  };

  // 关键字内容更新事件
  onKeysTextChange = e => {
    this.props.setValue({
      formInfo: {
        keys: e.target.value
      },
      model: this.props.modelName
    });
  };

  // 重置表单
  onReset = () => {
    this.props.setValue({
      formInfo: {
        keys: null,
        beginDate: null,
        endDate: null
      },
      model: this.props.modelName
    });
    this.props.onResetSearch();
  };

  render() {
    return (
      <div className="notice-search-form">
        <div className="notice-clear" onClick={this.onReset}>
          <i className="action-user action-shanchu" />
        </div>
        <div className="notice-search-content">
          <DateRangePicker
            width="220"
            field="beginDate"
            extField1="endDate"
            modelName={this.props.modelName}
            getValue={this.getDateRangeValue}
            onChange={this.dateChange}
          />
          <InputEnhance
            placeholder="请输入关键字"
            className="notice-keys"
            value={this.getKeysValue()}
            onChange={this.onKeysTextChange}
          />
        </div>
        <div className="notice-search" onClick={this.props.onSearch}>
          <i className="action-user action-sousuo" />
        </div>
      </div>
    );
  }
}

export default NoticeSearchForm;
